import React, { useState, useEffect } from 'react';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import OverviewSection from '../OverviewSection/OverviewSection';
import GasSection from '../GasSection/GasSection';
import LngSection from '../LngSection/LngSection';
import PowerSection from '../PowerSection/PowerSection';
import OilCoalSection from '../OilCoalSection/OilCoalSection';
import CurrencySection from '../CurrencySection/CurrencySection';

import { OverviewModel } from '../../core/models/overview';
import OverviewService from '../../core/services/overview-service';
import Loader from '../../components/Loader/Loader';
import { OverviewContext } from '../../core/context/overview-context';
import PdfPage from '../../components/PdfPage/PdfPage';

const overviewService = new OverviewService();

function Content(): JSX.Element {
  const [overview, setOverview] = useState<OverviewModel>({} as OverviewModel);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const ac = new AbortController();
    overviewService
      .getOverview(ac)
      .then((response) => {
        setOverview(response);
        setIsLoading(false);
      })
      .catch(console.error);
    return () => ac.abort();
  }, []);

  return isLoading ? (
    <div className="w-100 h-100">
      <Loader />
    </div>
  ) : (
    <div className="Content">
      <OverviewContext.Provider value={overview}>
        <PdfPage isHidden>
          <Header />
          <OverviewSection />
        </PdfPage>
        <GasSection />
        <PdfPage>
          <LngSection />
        </PdfPage>
        <PowerSection />
        <PdfPage>
          <OilCoalSection />
        </PdfPage>
        <PdfPage>
          <CurrencySection />
          <Footer />
        </PdfPage>
      </OverviewContext.Provider>
    </div>
  );
}

export default Content;
